import React, { useEffect } from 'react';
import { useStaticQuery, graphql, navigate } from 'gatsby';
import { Helmet } from 'react-helmet';
import SimpleReactLightbox from 'simple-react-lightbox';

import Utm from '~/utils/utm-tracking';
import Header from '~/components/Header';
import Footer from '~/components/Footer';
import TailwindPurgeClasses from '~/components/TailwindPurgeClasses';
import TransContext from '~/contexts/TransContext';
import useBrowserLang from '~/hooks/useBrowserLang';

const Layout = ({
  children,
  headerColor = 'white',
  hideHeader = false,
  hideFooter = false,
  hideFooterCta = false,
  hideSecondaryFooterCta = false,
  addBackgroundDefault = false,
  showHeaderNewsletter = false,
  footerColor,
  footerCTAContent,
  locale,
  location,
  ...other
}) => {
  const lang = useBrowserLang();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const isHomepage = /^\/((it)|(fr)|(es)|())\/?$/.test(window.location.pathname)
    if (!isHomepage) return;

    const langs = ['en', 'it', 'fr', 'es'];

    let langPath = '/'+lang+'/';
    let currentPathHasLang = window.location.pathname.split('/').includes(lang) === true;

    if (lang === 'en') {
      langPath = '/';
      currentPathHasLang = !currentPathHasLang;
    }

    if (lang && langs.includes(lang) && !currentPathHasLang) {
      navigate(langPath);
    }
  }, []);

  useEffect(() => {
    if (typeof window.console !== 'undefined') {
      const utm = new Utm({
        expires: 365,
      });
      utm.store();
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.Autopilot !== 'undefined' && typeof window.Autopilot.startFormScanLoop === 'function') {
      window.Autopilot.startFormScanLoop();
      // console.log('y');
    }
  });

  const { localeRaw } = useStaticQuery(graphql`
    query {
      localeRaw: storyblokEntry(field_component: {eq: "Global"}, lang: {eq: "default" }) {
        lang
        content
      }
    }
  `);

  if (!locale) {
    locale = {
      ...localeRaw,
      content: JSON.parse(localeRaw.content)
    }
  }


  return (
    <TransContext.Provider value={locale}>
      <SimpleReactLightbox>
        {/* Autopilot Tracking Code */}
        <Helmet
          script={[
            {
              innerHTML: `
              (function(o){var b="https://fastfinch.co/anywhere/",t="72524648c58349faa00743d591226c3cf10cb5913a28409a8656f087e4cf9335",a=window.AutopilotAnywhere={_runQueue:[],run:function(){this._runQueue.push(arguments);}},c=encodeURIComponent,s="SCRIPT",d=document,l=d.getElementsByTagName(s)[0],p="t="+c(d.title||"")+"&u="+c(d.location.href||"")+"&r="+c(d.referrer||""),j="text/javascript",z,y;if(!window.Autopilot) window.Autopilot=a;if(o.app) p="devmode=true&"+p;z=function(src,asy){var e=d.createElement(s);e.src=src;e.type=j;e.async=asy;l.parentNode.insertBefore(e,l);};y=function(){z(b+t+'?'+p,true);};if(window.attachEvent){window.attachEvent("onload",y);}else{window.addEventListener("load",y,false);}})({});
            `,
              type: 'text/javascript',
            },
          ]}
        />
        <div {...other}>
          {!hideHeader && (
            <Header
              headerColor={headerColor}
              addBackgroundDefault={addBackgroundDefault}
              showHeaderNewsletter={showHeaderNewsletter}
            />
          )}

          <div className={`${!hideHeader && 'pt-24'}`}>{children}</div>

          {!hideFooter && (
            <Footer
              footerColor={footerColor}
              footerCTAContent={footerCTAContent}
              hideFooterCta={hideFooterCta}
              hideSecondaryFooterCta={hideSecondaryFooterCta}
            />
          )}

          <TailwindPurgeClasses />
        </div>
      </SimpleReactLightbox>
    </TransContext.Provider>
  );
};

export default Layout;
